"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debugResponses = exports.debugRequests = void 0;

var _logger = _interopRequireDefault(require("../logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Format logs for DataDog.
 */
var format = function format(_ref) {
  var request = _ref.request,
      response = _ref.response,
      config = _ref.config,
      restProps = _objectWithoutProperties(_ref, ["request", "response", "config"]);

  var endTime = new Date();
  var logObj = {};

  if (!config) {
    return logObj;
  } // Note that the URL is built up from the config object, which is more likely
  // to exist, even if the response and request objects somehow don't


  var search = config.params ? "?".concat(config.paramsSerializer(config.params)) : '';
  var url = new URL("/".concat(config.url).concat(search).replace(/\/\//g, '/'), config.baseURL); // Also grab the headers from the config obj

  var _config$headers = config.headers,
      headers = _config$headers === void 0 ? {} : _config$headers;
  var normalisedHeaders = Object.keys(headers).reduce(function (acc, key) {
    acc[key.toLowerCase()] = headers[key];
    return acc;
  }, {}); // Attempt to parse the payload as JSON for better readability

  var payload;

  try {
    payload = JSON.parse(config.data);
  } catch (err) {
    payload = config.data;
  }

  try {
    var _config$method;

    logObj = _objectSpread({
      duration: (endTime - config._startTime) * 1000000,
      // in nanoseconds
      http: {
        url: url.href,
        status_code: response === null || response === void 0 ? void 0 : response.status,
        method: config === null || config === void 0 ? void 0 : (_config$method = config.method) === null || _config$method === void 0 ? void 0 : _config$method.toUpperCase(),
        referer: normalisedHeaders.referer || normalisedHeaders.referrer,
        useragent: normalisedHeaders['user-agent'],
        headers: headers,
        contentLength: response === null || response === void 0 ? void 0 : response.headers['content-length'],
        payload: payload,
        url_details: {
          host: url.hostname,
          port: url.port,
          path: url.pathname,
          queryString: config.params,
          scheme: url.protocol.replace(':', '')
        }
      }
    }, restProps);
  } catch (err) {
    _logger["default"].error(err); // In case log formatting goes wrong

  }

  return logObj;
};

var debugRequests = function debugRequests() {
  return {
    success: function success(config) {
      config._startTime = new Date();
      return config;
    }
  };
};

exports.debugRequests = debugRequests;

var debugResponses = function debugResponses() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      apiName = _ref2.apiName;

  var api = "".concat(apiName ? apiName.charAt(0).toUpperCase() + apiName.slice(1) : '', " API").trim();
  return {
    success: function success(response) {
      var _ref3 = response || {},
          config = _ref3.config,
          request = _ref3.request;

      _logger["default"].debug("".concat(api, " Request"), format({
        config: config,
        response: response,
        request: request,
        api: api
      }));

      return response;
    },
    error: function error(_error) {
      var config = _error.config,
          request = _error.request,
          response = _error.response,
          message = _error.message;

      var _ref4 = response || {},
          data = _ref4.data,
          status = _ref4.status;

      var fullMessage = message ? "".concat(api, " Error: ").concat(message) : "".concat(api, " Error");
      var log = !Number.isFinite(status) || status >= 500 ? _logger["default"].error : _logger["default"].warn;
      log(new Error(fullMessage), format({
        config: config,
        request: request,
        response: response,
        api: api,
        data: data
      }));
      throw _error;
    }
  };
};

exports.debugResponses = debugResponses;